import { __extends } from "tslib";
import { FilterUtils } from '../../../utils/FilterUtils';
import { MultipleUVTask } from './MultipleUVTask';
var FRAG_DEF = "\nprecision highp float;\n\nuniform sampler2D uBlur;\nuniform sampler2D uSource;\nuniform vec4 uColor;\n// strength, inner, not knokout, not hideObject\nuniform vec4 uProps;\nuniform vec2 uDir;\n\nvarying vec2 vUv[2];\n\nvoid main() {\n    vec4 color = uColor;\n\n    float outer = 1. - uProps[1];\n    float inner = uProps[1];\n\tfloat shadow = texture2D(uBlur, vUv[0] + uDir).a;\t\n\n\tvec4 main = texture2D(uSource, vUv[1]);\n\n\t// mask inner by main\n\tshadow = outer * shadow + (1. - shadow) * inner * main.a;\n\n\tcolor.a = clamp(color.a * shadow * uProps[0], 0., 1.);\n\tcolor.rgb *= color.a;\n\n\tif (uProps[3] > 0.0) {\n\t\tvec4 composite = main * uProps[2];\n\n\t\tcolor = \n\t\t\touter * (composite + (1. - main.a) * color) + \n\t\t\tinner * (composite * (1. - color.a) + color);\n\t}\n\t\n\tgl_FragColor = color;\n}";
var DropShadowTask = /** @class */ (function (_super) {
    __extends(DropShadowTask, _super);
    function DropShadowTask() {
        var _this = 
        // blur + source
        _super.call(this, 2) || this;
        _this._uColor = new Float32Array([0, 0, 0, 0]);
        // strength, inner, knokout, composite
        _this._uProps = new Float32Array([1, 0, 1, 1]);
        _this._uDir = new Float32Array([0, 0]);
        _this._color = 0x0;
        _this._alpha = 1;
        _this._angle = 0;
        _this._distance = 1;
        return _this;
    }
    Object.defineProperty(DropShadowTask.prototype, "strength", {
        get: function () {
            return this._uProps[0];
        },
        set: function (v) {
            this._uProps[0] = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "inner", {
        get: function () {
            return !!this._uProps[1];
        },
        set: function (v) {
            this._uProps[1] = v ? 1 : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "knockout", {
        get: function () {
            return !this._uProps[2];
        },
        set: function (v) {
            // invert for reduce invert in shader
            this._uProps[2] = v ? 0 : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "hideObject", {
        get: function () {
            return !this._uProps[3];
        },
        set: function (v) {
            this._uProps[3] = v ? 0 : 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (v) {
            this._color = v;
            FilterUtils.colorToArray(this._color, this._alpha, this._uColor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "alpha", {
        get: function () {
            return this._uColor[3];
        },
        set: function (v) {
            this._uColor[3] = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "angle", {
        get: function () {
            return this._angle;
        },
        set: function (v) {
            this._angle = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "distance", {
        get: function () {
            return this._distance;
        },
        set: function (v) {
            this._distance = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropShadowTask.prototype, "name", {
        get: function () {
            return 'DropShadowTask';
        },
        enumerable: false,
        configurable: true
    });
    DropShadowTask.prototype.getFragmentCode = function () {
        return FRAG_DEF;
    };
    DropShadowTask.prototype.activate = function (_stage) {
        var sourceImage = this.sourceImage;
        var inputImage = this._source;
        // UV for source
        this.uvMatrices[1].set([
            0, 0,
            this.inputRect.width / sourceImage.width,
            this.inputRect.height / sourceImage.height,
        ], 0);
        var rad = Math.PI * this._angle / 180;
        this._uDir[0] = -Math.cos(rad) * this._distance / inputImage.width;
        this._uDir[1] = -Math.sin(rad) * this._distance / inputImage.height;
        inputImage.getAbstraction(_stage).activate(0);
        sourceImage.getAbstraction(_stage).activate(1);
        // UV for base image should be computed automatically
        // call after compute uvMatrices
        this.uploadVertexData();
        this._program3D.uploadUniform('uColor', this._uColor);
        this._program3D.uploadUniform('uProps', this._uProps);
        this._program3D.uploadUniform('uDir', this._uDir);
    };
    return DropShadowTask;
}(MultipleUVTask));
export { DropShadowTask };
